import { createStore, combineReducers } from "redux";
import { devToolsEnhancer } from "redux-devtools-extension";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import notificationsReducer from "./reducers/notificationsReducer";
import userReducer from "./reducers/userReducer";

// combining reducers into a single reducer
const reducer = combineReducers({
  notificationsPermission: notificationsReducer,
  userId: userReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
});
const configureStore = createStore(reducer, devToolsEnhancer());
export default configureStore;
